import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import NoteForm, { NoteFormRef, NoteValues } from './NoteForm';

type AddNoteModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: NoteValues) => Promise<void>;
};

const AddNoteModal: React.FC<AddNoteModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
}: AddNoteModalProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<NoteFormRef>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddNewNote = async (values: NoteValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error('Failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.addNewNote']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <NoteForm formRef={formRef} onSubmit={handleAddNewNote} />
    </AppModalContainer>
  );
};

export default AddNoteModal;
